import { CustomColumn } from "../../../types/customColumn";
import { CashDrawerDTO } from "../../../types/hardware/CashDrawerTypes";

export const cashDrawerColumns: CustomColumn<CashDrawerDTO>[] = [
  {
    Header: 'Nombre',
    accessor: 'name',
    customCell: ({ row }) => (
      <span className="text-gray-700 dark:text-gray-300 text-sm">
        {row.original.name}
      </span>
    ),
  },
  {
    Header: 'Impresora',
    accessor: 'printerName',
    customCell: ({ row }) => (
      <span className="text-sm">{row.original.printerName}</span>
    ),
  },
  {
    Header: 'Comando',
    accessor: 'openCommand',
    customCell: ({ row }) => (
      <span className="text-sm">{row.original.openCommand}</span>
    ),
  },
  {
    Header: 'Estado',
    accessor: 'active',
    customCell: ({ row }) => {
      const status = row.original.active ? 'Activo' : 'Inactivo';
      const badgeClass = row.original.active
        ? 'bg-[#3CA745] text-white'
        : 'bg-[#DC3545] text-white';

      return (
        <span
          className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${badgeClass}`}
        >
          {status}
        </span>
      );
    },
  },
];
